import {Component, OnInit} from '@angular/core';
import {NavBaseComponent} from '../nav-base/nav-base.component';
import {TranslateService} from '../../shared/translate.service';

@Component({
  selector: 'app-nav-lang',
  templateUrl: './nav-lang.component.html',
  styleUrls: ['../nav-base/nav-base.component.scss']
})
export class NavLangComponent extends NavBaseComponent implements OnInit {

  chosenLang: string;

  showLang = false;

  constructor(public translateService: TranslateService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  toggleLang() {
    this.showLang = !this.showLang;
  }

  chosenLangEmitter(chosenLang) {
    this.chosenLang = chosenLang;
  }
}
